import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "preact/jsx-runtime";
import { render } from "preact";
import { useEffect, useRef } from "preact/hooks";
const Lightbox = (props) => {
    const imagesRef = useRef(props.gallery.map(() => undefined));
    const closeRef = useRef(null);
    const controlRef = useRef([]);
    let activeIndex = 0;
    const setActive = (direction) => {
        var _a, _b;
        let nextIndex = direction === 0 ? activeIndex - 1 : activeIndex + 1;
        if (nextIndex < 0)
            nextIndex = props.gallery.length - 1;
        if (nextIndex >= props.gallery.length)
            nextIndex = 0;
        (_a = imagesRef.current[activeIndex]) === null || _a === void 0 ? void 0 : _a.classList.remove("active");
        (_b = imagesRef.current[nextIndex]) === null || _b === void 0 ? void 0 : _b.classList.add("active");
        activeIndex = nextIndex;
    };
    const handleKeyPress = (event) => {
        switch (event.key) {
            case "Escape":
                props.closeCallback();
                break;
            case "ArrowLeft":
                setActive(0);
                break;
            case "ArrowRight":
                setActive(1);
                break;
        }
    };
    const yBuffer = 50;
    const timeBuffer = 350;
    let touchStartTime = 0;
    let touchStart = {
        clientX: 0,
        clientY: 0,
    };
    let touchCurrent = {
        clientX: 0,
        clientY: 0,
    };
    const handleTouchStart = (event) => {
        touchStart = event.touches[0];
        touchStartTime = Date.now();
    };
    const handleTouchMove = (event) => {
        touchCurrent = event.touches[0];
    };
    const handleTouchEnd = () => {
        const deltaX = Math.abs(touchCurrent.clientX - touchStart.clientX);
        const deltaY = Math.abs(touchCurrent.clientY - touchStart.clientY);
        if (deltaY > deltaX)
            return;
        if (Math.abs(touchCurrent.clientY - touchStart.clientY) > yBuffer)
            return;
        if (Math.abs(touchStartTime - Date.now()) > timeBuffer)
            return;
        if (touchCurrent.clientX > touchStart.clientX) {
            setActive(0);
        }
        else {
            setActive(1);
        }
        touchStart = {
            clientX: 0,
            clientY: 0,
        };
        touchCurrent = {
            clientX: 0,
            clientY: 0,
        };
    };
    useEffect(() => {
        var _a;
        if (closeRef.current)
            closeRef.current.focus();
        window.addEventListener("keydown", handleKeyPress);
        window.addEventListener("touchstart", handleTouchStart);
        window.addEventListener("touchmove", handleTouchMove);
        window.addEventListener("touchend", handleTouchEnd);
        document.documentElement.style.overflowY = "hidden";
        (_a = imagesRef.current[0]) === null || _a === void 0 ? void 0 : _a.classList.add("active");
        if (controlRef.current) {
            controlRef.current.forEach((button, index) => {
                button === null || button === void 0 ? void 0 : button.addEventListener("click", () => {
                    setActive(index);
                });
            });
        }
        return () => {
            window.removeEventListener("keypress", handleKeyPress);
            window.removeEventListener("touchstart", handleTouchStart);
            window.removeEventListener("touchmove", handleTouchMove);
            window.removeEventListener("touchend", handleTouchEnd);
            document.documentElement.style.overflowY = "";
        };
    }, [props.gallery.length]);
    return (_jsxs("div", { class: "lightbox hidden", children: [_jsxs("div", { class: "lightbox__wrapper", children: [_jsx("button", { class: "lightbox__close", onClick: props.closeCallback, ref: closeRef, children: "Sluiten" }), _jsxs("div", { class: "lightbox__gallery", children: [props.gallery.map((image, index) => (_jsx("div", { dangerouslySetInnerHTML: { __html: image.outerHTML }, class: `lightbox__image-container`, ref: (el) => {
                                    imagesRef.current[index] = el;
                                } }))), _jsx("div", { class: "lightbox__description", dangerouslySetInnerHTML: { __html: props.description.innerHTML } })] })] }), _jsxs("div", { class: "lightbox__controls", children: [_jsx("button", { class: "lightbox__control-button", ref: (el) => {
                            controlRef.current[0] = el;
                        }, children: "Vorige" }), _jsx("button", { class: "lightbox__control-button", ref: (el) => {
                            controlRef.current[1] = el;
                        }, children: "Volgende" })] }), _jsx("div", { class: "lightbox__backdrop", onClick: props.closeCallback })] }));
};
export default function initProjectLightbox() {
    const projectItems = document.querySelectorAll(".project");
    if (!projectItems.length)
        return;
    const renderTarget = document.getElementById("lightbox-render-target");
    if (!renderTarget)
        return;
    projectItems.forEach((project) => {
        const gallery = project.querySelector(".project__gallery");
        const description = project.querySelector(".project__description");
        if (!gallery || !description)
            return;
        const galleryItems = gallery.querySelectorAll("img");
        if (!galleryItems.length)
            return;
        const closeCallback = () => {
            render(_jsx(_Fragment, {}), renderTarget);
        };
        project.addEventListener("click", (event) => {
            if (event.target.tagName === "A")
                return;
            render(_jsx(Lightbox, { gallery: [...galleryItems], description: description, closeCallback: closeCallback }), renderTarget);
        });
    });
}
